import { render, staticRenderFns } from "./meta.vue?vue&type=template&id=15585d26&"
import script from "./meta.vue?vue&type=script&lang=js&"
export * from "./meta.vue?vue&type=script&lang=js&"
import style0 from "./meta.vue?vue&type=style&index=0&id=15585d26&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports